import useClasslinkLoginButton from './useClasslinkLoginButton.hook';
import SignInButton from '../SignInButton/SignInButton';

export default function ClasslinkLoginButton({
  text,
  redirectTo,
  redirectErrorTo,
  stateParams,
}) {
  const { state } = useClasslinkLoginButton({
    redirectTo,
    redirectErrorTo,
    stateParams,
  });

  return (
    <SignInButton
      url={state.loginUrl}
      text={text}
      logo={
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/img/classlink-white.png'
      }
      logoAlt="ClassLink"
      logoWidth="100px"
      logoHeight="17px"
      provider="classlink"
    />
  );
}
